import React from "react";

import Check from "@uui/Check";
import { first, isEqual } from "lodash/fp";

import { Popover } from "@mui/material";

import useAnchorElement from "@app/utils/hooks/useAnchorElement";

import { LIST_GAP_PX, ColorList, ColorSquare } from "./styles";

export interface Color {
  backgroundColor: string;
  color: string;
}

export interface ColorPickerProps {
  colors: Color[];
  onChange?: (color: Color) => void;
  selected?: Color;
}

const ColorPicker = ({ colors, onChange, selected }: ColorPickerProps) => {
  const { open, onClose, onClick, anchorElement } = useAnchorElement();

  const handleSelectColor = (color: Color) => {
    if (!onChange) return;

    return (event: React.MouseEvent<HTMLElement>) => {
      event.stopPropagation();
      onChange(color);
      onClose();
    };
  };

  const selectedColor = selected ?? first(colors);

  const handleClick: typeof onClick = (event) => {
    event.stopPropagation();
    onClick(event);
  };

  return (
    <>
      <ColorSquare
        onClick={onChange ? handleClick : undefined}
        sx={selectedColor}
      />
      <Popover
        open={open}
        onClose={onClose}
        anchorEl={anchorElement}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{
          vertical: LIST_GAP_PX,
          horizontal: -LIST_GAP_PX / 2,
        }}
      >
        <ColorList>
          {colors.map((color) => {
            const isSelected = isEqual(selectedColor, color);
            return (
              <ColorSquare
                key={color.backgroundColor}
                sx={color}
                onClick={handleSelectColor(color)}
              >
                {isSelected ? (
                  <Check sx={{ color: color.color }} />
                ) : (
                  <span>a</span>
                )}
              </ColorSquare>
            );
          })}
        </ColorList>
      </Popover>
    </>
  );
};

export default ColorPicker;
